import React from 'react';
import { useLocation } from 'react-router-dom';
import Chatbot from './Chatbot';

const ChatbotController = () => {
  const location = useLocation();
  
  // Only show chatbot on these pages
  const chatbotEnabledPages = [
    '/', // Home page
    '/events', // Events listing
    '/updates', // Updates listing
    '/contact', // Contact page
  ];
  
  // Check if current path should show the chatbot
  const shouldShowChatbot = chatbotEnabledPages.some(page => 
    location.pathname === page || 
    (page !== '/' && location.pathname.startsWith(page + '/'))  // For sub-pages like /events/123
  );
  
  if (!shouldShowChatbot) {
    return null;
  }
  
  return (
    <div className="fixed bottom-4 right-4 z-[100]">
      <Chatbot />
    </div>
  );
};

export default ChatbotController;
